'use client'

import React, { useState, useCallback } from 'react'
import styles from './Posts.module.css'

interface CreatePostFormProps {
  onSubmit: (content: string) => Promise<void>
  selectedSymbol?: string
  selectedLtp?: number
}

export const CreatePostForm = React.memo(({ onSubmit, selectedSymbol, selectedLtp }: CreatePostFormProps) => {
  const [content, setContent] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Handle form submission
  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault()
    if (!content.trim() || isSubmitting) return

    setIsSubmitting(true)
    try {
      await onSubmit(content.trim())
      setContent('') // Clear form after successful submission
    } catch (error) {
      console.error('Error submitting post:', error)
    } finally {
      setIsSubmitting(false)
    }
  }, [content, isSubmitting, onSubmit])

  // Handle textarea content change
  const handleContentChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value)
  }, [])

  return (
    <form onSubmit={handleSubmit} className={styles.createPostForm}>
      {selectedSymbol && selectedLtp && (
        <div className={styles.symbolInfo}>
          📈 Posting about: <strong>{selectedSymbol}</strong> (₹{selectedLtp.toFixed(2)})
        </div>
      )}
      <div className={styles.formGroup}>
        <textarea
          value={content}
          onChange={handleContentChange}
          placeholder={`Share your thoughts about ${selectedSymbol || 'this symbol'}...`}
          rows={3}
          maxLength={500}
          className={styles.textarea}
          disabled={isSubmitting}
        />
        <div className={styles.charCount}>
          {content.length}/500
        </div>
      </div>
      <button 
        type="submit" 
        disabled={!content.trim() || isSubmitting}
        className={styles.submitButton}
      >
        {isSubmitting ? 'Posting...' : 'Post'}
      </button>
    </form>
  )
}) 